import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import Price from '../Price/Price';
import {BasketFeeStyled} from './BasketFee.style';

const BasketFee = ({messageStringId, promotionMessage, total}) => {
  const renderFee = messageStringId ? <FormattedMessage id={messageStringId} /> : <span>{promotionMessage}</span>;

  return (
    <BasketFeeStyled>
      <span>
        {renderFee}
      </span>
      <Price amount={total} />
    </BasketFeeStyled>
  );
};

BasketFee.propTypes = {
  messageStringId: PropTypes.string,
  promotionMessage: PropTypes.string,
  total: PropTypes.number.isRequired
};

export default BasketFee;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketFee.js